import React, { useState, useEffect } from 'react';

const SystemFeedbackModal = ({ onClose }) => {
    const [rating, setRating] = useState(0);
    const [hovered, setHovered] = useState(0);
    const [comment, setComment] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const [canDismiss, setCanDismiss] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setCanDismiss(true), 10000);
        return () => clearTimeout(timer);
    }, []);

    const handleSubmit = async () => {
        if (rating === 0) {
            setError('Por favor, selecione uma nota.');
            return;
        }
        if (rating < 5) {
            const wordCount = comment.trim().split(/\s+/).filter(w => w.length > 0).length;
            if (wordCount < 10) {
                setError('Por favor, escreva pelo menos 10 palavras no comentário.');
                return;
            }
        }
        setSubmitting(true);
        setError(null);
        try {
            const { submitSystemFeedback } = await import('../../utils/requestUtils');
            await submitSystemFeedback(rating, comment.trim());
            onClose();
        } catch (e) {
            setError('Erro ao enviar avaliação. Tente novamente.');
        } finally {
            setSubmitting(false);
        }
    };

    const overlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'var(--color-overlay-scrim)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    };

    const modalStyle = {
        backgroundColor: '#fff',
        borderRadius: '12px',
        padding: '32px 28px 24px',
        width: '340px',
        maxWidth: '92vw',
        boxShadow: '0 8px 32px var(--color-modal-shadow)',
        position: 'relative',
    };

    const starStyle = (index) => ({
        fontSize: '32px',
        cursor: 'pointer',
        color: index <= (hovered || rating) ? '#FFB353' : '#d4ccc6',
        transition: 'color 0.15s',
        padding: '0 3px',
        userSelect: 'none',
    });

    return (
        <div style={overlayStyle}>
            <div style={modalStyle}>
                {canDismiss && (
                    <button
                        onClick={onClose}
                        style={{
                            position: 'absolute',
                            top: '12px',
                            right: '14px',
                            background: 'none',
                            border: 'none',
                            fontSize: '18px',
                            cursor: 'pointer',
                            color: 'var(--color-text-secondary)',
                            padding: '4px',
                            lineHeight: 1,
                        }}
                        aria-label="Fechar"
                    >
                        ✕
                    </button>
                )}

                <h3 style={{ margin: '0 0 6px', color: 'var(--color-text-heading)', fontSize: '17px' }}>
                    O que você acha do sistema?
                </h3>
                <p style={{ margin: '0 0 18px', color: 'var(--color-text-secondary)', fontSize: '13px' }}>
                    Sua opinião nos ajuda a melhorar. Esta pesquisa aparece apenas uma vez.
                </p>

                <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                    <div style={{ marginBottom: '6px' }}>
                        {[1, 2, 3, 4, 5].map((star) => (
                            <span
                                key={star}
                                style={starStyle(star)}
                                onClick={() => setRating(star)}
                                onMouseEnter={() => setHovered(star)}
                                onMouseLeave={() => setHovered(0)}
                                role="button"
                                aria-label={`${star} estrela${star > 1 ? 's' : ''}`}
                            >
                                ★
                            </span>
                        ))}
                    </div>
                    {rating > 0 && (
                        <span style={{ fontSize: '12px', color: 'var(--color-text-secondary)' }}>
                            {['', 'Muito insatisfeito', 'Insatisfeito', 'Neutro', 'Satisfeito', 'Muito satisfeito'][rating]}
                        </span>
                    )}
                </div>

                <div style={{ marginBottom: '18px' }}>
                    <label style={{ display: 'block', fontSize: '13px', color: 'var(--color-text-secondary)', marginBottom: '6px' }}>
                        Comentário (elogios, melhorias ou sugestões):{rating > 0 && rating < 5 && <span style={{ color: 'var(--semantic-error-text)' }}> mín. 10 palavras</span>}
                    </label>
                    <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        rows={4}
                        maxLength={1000}
                        placeholder="Escreva aqui..."
                        style={{
                            width: '100%',
                            resize: 'vertical',
                            fontSize: '13px',
                            padding: '8px',
                            borderRadius: '6px',
                            border: '1px solid var(--color-input-border)',
                            boxSizing: 'border-box',
                            fontFamily: 'inherit',
                        }}
                    />
                </div>

                {error && (
                    <p style={{ color: 'var(--semantic-error-text)', fontSize: '13px', margin: '0 0 12px' }}>
                        {error}
                    </p>
                )}

                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    {canDismiss && (
                        <button
                            onClick={onClose}
                            style={{ background: 'var(--btn-mute-bg)', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 18px', cursor: 'pointer', fontSize: '13px' }}
                        >
                            Depois
                        </button>
                    )}
                    <button
                        onClick={handleSubmit}
                        disabled={submitting}
                        style={{ background: 'var(--btn-primary-bg)', color: '#fff', border: 'none', borderRadius: '6px', padding: '8px 18px', cursor: submitting ? 'not-allowed' : 'pointer', fontSize: '13px' }}
                    >
                        {submitting ? 'Enviando...' : 'Enviar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SystemFeedbackModal;
